import { Box, Stack, Typography } from "@mui/material";
import { Avatar } from "../../commons/Avatar.js";
import { SupplierListItemFragment } from "./SupplierListItem.generated.js";

interface Props {
  supplier: SupplierListItemFragment;
}

export const SupplierListItem = ({ supplier }: Props) => {
  return (
    <Stack direction="row" spacing={1}>
      <Box>
        <Avatar
          url={supplier.logo?.url}
          initials={supplier.title.substring(0, 2)}
          size="m"
          type="square"
        />
      </Box>
      <Typography
        variant={"h4"}
        sx={{
          alignSelf: "center",
        }}
      >
        <span>{supplier.title}</span>
      </Typography>
    </Stack>
  );
};
